import { atom } from "recoil";

export const titles = atom<{
  news: {
    id: number;
    title: string;
  }[];
  main_text: string;
}>({
  key: "titlesKey",
  default: {
    news: [],
    main_text: "",
  },
});
